import React, { useState } from "react";
import SidebarPanel from "./SidebarPanel";
import { useAuth } from "../context/UserContext";
import { Profileinfo } from "./Layout/Profileinfo";
import { Footer } from "./Layout/Footer";
import { FaRunning, FaGift, FaExclamationCircle } from "react-icons/fa";

const Account = () => {
  const { user,limit } = useAuth();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("standard");

  const handleSubscribeClick = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="flex bg-gray-100 min-h-screen">
      <SidebarPanel className="w-64 fixed top-0 left-0 h-full bg-primary shadow-lg" />
      <div className="flex-1 ml-64 bg-gray-50 p-6">
        <Profileinfo />
        <div className="flex items-center">
          <div className="flex items-center mx-auto justify-center">
            <main className="max-w-[600px] w-full mx-auto p-8 bg-gray-800 shadow-lg rounded-md">
              <h1 className="text-3xl font-bold text-center text-white mb-8">
                Account Details
              </h1>
              <div className="grid grid-cols-1 gap-6 text-center">
                <div>
                  <img
                    src={user.user_metadata.picture}
                    alt="User Avatar"
                    className="w-28 h-28 rounded-full mx-auto border border-gray"
                  />
                </div>
                <div>
                  <h2 className="text-2xl font-semibold text-gray-300">
                    {user.user_metadata.full_name}
                  </h2>
                </div>
                <div>
                  <p className="text-lg text-gray-400">{user.email}</p>
                </div>
                <div className="text-gray-400">
                  <div className="flex items-center justify-center mb-2">
                    <FaRunning className="text-primary-500 mr-2" />
                    <span>Total lifetime runs: 50</span>
                  </div>
                  <div className="flex items-center justify-center mb-2">
                    <FaGift className="text-green-500 mr-2" />
                    <span>Free runs remaining: <span>{limit}</span></span>
                  </div>
                  <div className="flex items-center justify-center">
                    <FaExclamationCircle className="text-red-500 mr-2" />
                    <span>No active plan.</span>
                  </div>
                  <button
                    className="mt-4 px-4 py-2 hover:bg-tertiary hover:text-white rounded bg-secondary text-black"
                    onClick={handleSubscribeClick}
                  >
                    Subscribe
                  </button>
                </div>
              </div>
            </main>
          </div>
        </div>

        <Footer position="absolute" />

        {isModalVisible && (
          <div
            id="modal"
            className="fixed inset-0 z-50 flex text-center items-center justify-center bg-gray-800 bg-opacity-50"
          >
            <div className="bg-white rounded-lg shadow-lg w-96">
              <div className="flex justify-between items-center p-4 border-b">
                <h2 className="text-lg font-bold text-black">Subscribe to a plan</h2>
                <button
                  onClick={handleCancel}
                  className="text-gray-500 hover:text-gray-700"
                >
                  ×
                </button>
              </div>
              <div className="p-4">
                <ul className="flex justify-center border-b mb-4">
                  <li
                    className={`mr-4 cursor-pointer ${
                      activeTab === "standard"
                        ? "text-primary border-b-2 border-primary"
                        : "text-gray-500"
                    }`}
                    onClick={() => setActiveTab("standard")}
                  >
                     Standard Plan
                  </li>
                  <li
                    className={`cursor-pointer ${
                      activeTab === "plan2"
                        ? "text-primary border-b-2 border-primary"
                        : "text-gray-500"
                    }`}
                    onClick={() => setActiveTab("plan2")}
                  >
                Premium Plan
                  </li>
                </ul>
                {activeTab === "standard" && (
                  <div>
                    <h3 className="text-lg font-semibold mb-2">
                      Standard Plan
                    </h3>
                    <p>$10.99 per month, billed annually.</p>
                    <button className="w-full px-4 py-2 bg-primary text-white rounded mt-2 hover:bg-secondary hover:text-black">
                      Subscribe to Standard Plan
                    </button>
                  </div>
                )}
                {activeTab === "plan2" && (
                  <div>
                    <h3 className="text-lg font-semibold mb-2">
                      Premium Plan
                    </h3>
                    <p>$24.99 per month, billed annually.</p>
                    <button className="w-full px-4 py-2 bg-primary text-white rounded mt-2 hover:bg-secondary hover:text-black">
                      Subscribe to Premium Plan
                    </button>
                  </div>
                )}
              </div> 
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Account;